import * as React from 'react';
import type { VariantProps } from 'class-variance-authority';
import { cva } from 'class-variance-authority';
import { cn } from '../../utils/cn';

// Default variant should match shadcn/ui as close as possible.
// https://ui.shadcn.com/docs/components/drawer
const drawerHeaderVariants = cva('flex flex-col gap-0.5 md:gap-2', {
    variants: {
        variant: {
            default: 'p-4',
            border: 'border-gray-900/30 relative border-b px-6 pb-4 pt-6 md:pb-4.5 md:pt-7',
        },
        alignment: {
            default:
                'group-data-[vaul-drawer-direction=bottom]/drawer-content:text-center group-data-[vaul-drawer-direction=top]/drawer-content:text-center md:text-left',
            center: 'text-center',
            left: 'text-left',
        },
    },
    defaultVariants: {
        variant: 'default',
        alignment: 'default',
    },
});

export function DrawerHeader({
    className,
    variant,
    alignment,
    ...props
}: React.ComponentProps<'div'> & VariantProps<typeof drawerHeaderVariants>) {
    return (
        <div
            data-slot="drawer-header"
            className={cn(
                drawerHeaderVariants({ variant, alignment, className }),
            )}
            {...props}
        />
    );
}
